export enum PartnerType {
  User = 'user',
  Admin = 'admin',
}
